import { render } from "./add.vue?vue&type=template&id=18c18b5e&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=18c18b5e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-18c18b5e"

export default script